import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-cream" data-id="element-87" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-88" data-mp="1cf03nb26x4mz">
        <div className="text-center mb-16" data-id="element-89" data-mp="1cgb8le7dgifo">
          <p className="text-terracotta font-semibold tracking-[0.18em] uppercase text-xs mb-3" data-id="element-90" data-mp="2a1ytb1ugtcbd">
            Todo lo que necesitas saber
          </p>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-charcoal" data-id="element-91" data-mp="253p19041ertz">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-92" data-mp="1v5823fuy36wu">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="bg-paper border border-warmgray rounded-xl overflow-hidden" data-id="element-93" data-mp="oqgxp26m53y2" data-mpi={index}>
                <h3 data-id="element-94" data-mp="1knzzcf04icvg">
                  <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between gap-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-terracotta" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} data-id="element-95" data-mp="1kngofi8w4oqx">
                    <span className="font-bold text-base md:text-lg text-charcoal" data-id="element-96" data-mp="11ve51z4v6ucz">
                      {faq.q}
                    </span>
                    <ChevronDown className={`text-terracotta transition-transform duration-200 ease-out shrink-0 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-97" data-mp="rzueztczepw5" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-98" data-mp="mzq54m6kwtew">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-99" data-mp="n1sxvdz490nb">
                      <div className="px-6 pb-5 text-charcoal-soft border-t border-warmgray pt-4" data-id="element-100" data-mp="2yp63s5l8noh4">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}